// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartStyle_tabs__sjRkn {
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  padding-left: 1rem;
}

.chartStyle_tab__u3GXk {
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  background: #e9f5f3;
  padding: 1rem;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.chartStyle_tab__active__ydHC4 {
  color: white; /* change to the color you want for the active tab */
  background: #e0a901;
}

.chartStyle_tab__name__ulJm8 {
  text-transform: capitalize;
}

.chartStyle_tab__number__FJRbL {
  font-size: 2rem;
  padding: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/company_overview/dashboard/graph/chartStyle.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,YAAY,EAAE,oDAAoD;EAClE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":[".tabs {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 1rem;\n  padding-left: 1rem;\n}\n\n.tab {\n  font-size: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  background: #e9f5f3;\n  padding: 1rem;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n\n.tab__active {\n  color: white; /* change to the color you want for the active tab */\n  background: #e0a901;\n}\n\n.tab__name {\n  text-transform: capitalize;\n}\n\n.tab__number {\n  font-size: 2rem;\n  padding: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `chartStyle_tabs__sjRkn`,
	"tab": `chartStyle_tab__u3GXk`,
	"tab__active": `chartStyle_tab__active__ydHC4`,
	"tab__name": `chartStyle_tab__name__ulJm8`,
	"tab__number": `chartStyle_tab__number__FJRbL`
};
export default ___CSS_LOADER_EXPORT___;
